import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import I18n from 'I18n';
import { EERIE } from 'HubStyleTokens/colors';
import UIFlex from 'UIComponents/layout/UIFlex';
import UICurrencyInput from 'UIComponents/input/UICurrencyInput';
import UIIcon from 'UIComponents/icon/UIIcon';
import * as ThemeQueryField from 'marketplace-ui-assets-core/constants/ThemeQueryField';
import { debounce } from 'marketplace-ui-common/utils/debounce';
import { formatCentsToDollars, formatDollarsToCents } from 'marketplace-ui-common/utils/currency';

const floorCentsToNearestDollar = cents => cents - cents % 100;

const minPlaceholderCents = 0;
const maxPlaceholderCents = 10000;

const PriceRangeInput = ({
  onFilterChange,
  priceRangeValue
}) => {
  const [minCents, setMinCents] = useState(priceRangeValue ? priceRangeValue.minCents : null);
  const [maxCents, setMaxCents] = useState(priceRangeValue ? priceRangeValue.maxCents : null);
  const handlePriceRangeChange = useCallback((newMinCents, newMaxCents) => {
    setMinCents(newMinCents);
    setMaxCents(newMaxCents);

    if (newMinCents !== null && newMaxCents !== null) {
      onFilterChange(ThemeQueryField.PRICE_RANGE, {
        minCents: newMinCents,
        maxCents: newMaxCents
      });
    }
  }, [onFilterChange]);
  return /*#__PURE__*/_jsxs(UIFlex, {
    className: "p-left-6",
    align: "center",
    wrap: "wrap",
    children: [/*#__PURE__*/_jsx(UICurrencyInput, {
      currency: "USD",
      name: "lowest-price",
      onChange: debounce(evt => handlePriceRangeChange(floorCentsToNearestDollar(formatDollarsToCents(evt.target.value)), maxCents)),
      placeholder: I18n.formatCurrency(formatCentsToDollars(minPlaceholderCents), {
        currencyCode: 'USD'
      }),
      value: minCents ? formatCentsToDollars(minCents) : undefined,
      style: {
        width: 68
      },
      max: maxCents !== null ? formatCentsToDollars(maxCents) : Infinity
    }), /*#__PURE__*/_jsx(UIIcon, {
      className: "m-x-2",
      color: EERIE,
      name: "next",
      size: "xxs"
    }), /*#__PURE__*/_jsx(UICurrencyInput, {
      currency: "USD",
      name: "highest-price",
      onChange: debounce(evt => handlePriceRangeChange(minCents, floorCentsToNearestDollar(formatDollarsToCents(evt.target.value)))),
      placeholder: I18n.formatCurrency(formatCentsToDollars(maxPlaceholderCents), {
        currencyCode: 'USD'
      }),
      value: maxCents !== null ? formatCentsToDollars(maxCents) : undefined,
      style: {
        width: 68
      },
      min: minCents !== null ? formatCentsToDollars(minCents) : 0
    })]
  });
};

export default PriceRangeInput;